/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateOrganisationListItemDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	candidacyCount: z.number(),
})

export type CandidateOrganisationListItemDataSchema = z.infer<typeof candidateOrganisationListItemDataSchema>
